@if (product) {
<div class="p-r-2 p-l-2 pe-none _wrapper">
    <div class="w-12 pos-relative pe-auto _inner">
        <wishlist-message class="fill z-2"
                          [product]="product"
                          [listPosition]="listPosition" />
    </div>
</div>
}